import { createFileRoute } from '@tanstack/react-router';

import { ScreenStub } from '@/components/layout/ScreenStub';

export const Route = createFileRoute('/notifications')({
  component: Screen,
});

function Screen() {
  return (
    <ScreenStub
      eyebrow="Compose & deliver"
      title="Notifications & Push"
      capability="notifications.view"
      planned="Composer with audience targeting, previews as an iOS lock screen and in the in-app inbox, template library, delivery log with per-device success/failure, and the device registry. Sending is Tier 3 — it is irreversible and reaches real phones."
    />
  );
}
